import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';

@Injectable()
export class MapsDashboardService extends ApiService {
  constructor(private http: Http) {
    super('api/dashboard/', http);
  }

  getStatistics(): Observable<any> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/maps-dashboard.service.ts